import ActionNode from './ActionNode'

class ActionNodeEndAutomation extends ActionNode {
  constructor(props) {
    super(props)
    this.text = 'End this automation'
    this.icon = {
      ...this.icon,
      name: 'refresh',
      size: 18
    }
  }
}

export default ActionNodeEndAutomation



// WEBPACK FOOTER //
// ./src/utils/models/node/ActionNodeEndAutomation.js